import type { AuthContextProps } from 'react-oidc-context';
import { isOidcCallbackRequest } from './platform/runtime';

const AUTH_TRANSITION_PATHS = new Set([
  '/signin-oidc',
  '/signout-callback-oidc',
]);

let recoveryInProgress = false;

const isBrowserRecoveryBlocked = (): boolean => {
  if (typeof window === 'undefined') {
    return true;
  }

  if (AUTH_TRANSITION_PATHS.has(window.location.pathname)) {
    return true;
  }

  return isOidcCallbackRequest();
};

export const restartAuthentication = async (
  auth: Pick<
    AuthContextProps,
    'activeNavigator' | 'clearStaleState' | 'removeUser' | 'signinRedirect'
  >
): Promise<void> => {
  if (recoveryInProgress || auth.activeNavigator || isBrowserRecoveryBlocked()) {
    return;
  }

  recoveryInProgress = true;

  try {
    await auth.clearStaleState().catch(() => undefined);
    await auth.removeUser().catch(() => undefined);
    await auth.signinRedirect();
  } finally {
    window.setTimeout(() => {
      recoveryInProgress = false;
    }, 1500);
  }
};
